import React, { useMemo } from 'react';
import './index.scss';
import { message, Modal, Popover } from 'antd';
import { request } from '@/fetch/core';
import { Method } from '@/fetch/core/util';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { getClstag } from '@/utils/util';
import { HttpStatusCode } from '@/fetch/core/constant';

const MessageMap = new Map([
  [
    'POWER_OFF',
    {
      text: '下电指令下发后将无法撤回，您是否确认将无人车远程关机？',
      pathUri: '/monitor/web/drive/command/send/power_off',
    },
  ],
  [
    'REBOOT',
    {
      text: '重启指令下发后将无法撤回，您是否确认将无人车断电重启？',
      pathUri: '/monitor/web/drive/command/send/power_reboot',
    },
  ],
  [
    'RESTART',
    {
      text: '是否确定软件重启？',
      pathUri: '/monitor/web/drive/command/send/remote-restart',
    },
  ],
  [
    'POWER_ON',
    {
      text: '是否确定无人车远程开机？',
      pathUri: '/monitor/web/command/powerOn',
    },
  ],
]);

const Restart = (props: {
  vehicleName: string;
  cockpitNumber: string;
  takeOverBySelf: boolean;
}) => {
  const cockpitMode = useSelector(
    (state: RootState) => state.newCommon?.cockpitMode
  );
  const userName = useSelector(
    (state: RootState) => state.login?.userInfo?.userName
  );

  const btnGroup: any[] = useMemo(
    () => [
      {
        text: '远程下电',
        commandType: 'POWER_OFF',
        clstag: getClstag(cockpitMode, 'SinglePage_PowerOff'),
      },
      {
        text: '断电重启',
        commandType: 'REBOOT',
        clstag: getClstag(cockpitMode, 'SinglePage_Reboot'),
      },
      {
        text: '软件重启',
        commandType: 'RESTART',
        clstag: getClstag(cockpitMode, 'SinglePage_SoftwareReboot'),
      },
      {
        text: '远程开机',
        commandType: 'POWER_ON',
        clstag: getClstag(cockpitMode, 'SinglePage_PowerOn'),
      },
    ],
    [cockpitMode]
  );

  const handleClick = (commandType: string) => {
    Modal.confirm({
      className: 'command-confirm',
      title: MessageMap.get(commandType)!.text,
      onOk: () => {
        if (commandType === 'POWER_ON') {
          request({
            path: '/monitor/web/command/powerOn',
            method: Method.POST,
            body: {
              vehicleName: props.vehicleName,
              operateType: 'powerOn',
            },
          }).then((res) => {
            if (res.code === HttpStatusCode.Success) {
              message.success('指令下发成功');
            } else {
              message.error(res.message);
            }
          });
        } else {
          request({
            path: MessageMap.get(commandType)?.pathUri,
            method: Method.POST,
            body: {
              cockpitNumber: props.cockpitNumber,
              vehicleName: props.vehicleName,
              cockpitUserName: userName,
            },
          }).then((res) => {
            if (res.code === HttpStatusCode.Success) {
              message.success('指令下发成功');
            } else {
              message.error(res.message);
            }
          });
        }
      },
    });
  };
  const popContent = (
    <div className="pop-content">
      {btnGroup.map((item) => (
        <div
          style={{ cursor: 'pointer' }}
          key={item.commandType}
          onClick={() => {
            handleClick(item.commandType);
          }}
          clstag={item.clstag}
        >
          {item.text}
        </div>
      ))}
    </div>
  );
  return (
    <>
      <Popover trigger={'click'} content={popContent}>
        <li className="btn-item restart">
          <i>远程重启</i>
        </li>
      </Popover>
    </>
  );
};

export default React.memo(Restart);
